import styled from 'styled-components';
import { MediumSectionHeader } from 'components/Typography';
import { Grid } from '@material-ui/core';

export const MediumSectionHeaderStyled = styled(MediumSectionHeader)`
text-align: center; !important;
`;
export const StyledGridButton = styled(Grid)`
margin-top: 20px; !important;
`;
export const StyledBodyText = styled.p`
  white-space: pre-line;
  color: #162952;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  max-height: 500px;
  margin: 0px;
  overflow: auto;
`;
